module.exports = __webpack_public_path__ + "img/jyw.dd3137b5.png";